<template>
  <div class="container mt-4">
    <h2 class="mb-4">Operations Dashboard</h2>
    <div class="row">
  <div class="col-md-3 mb-4" v-for="card in visibleCards" :key="card.id">

    <!-- External link card -->
    <a
      v-if="card.external"
      :href="card.external"
      target="_blank"
      rel="noopener"
      class="text-decoration-none"
    >
      <div class="card text-white" :class="`bg-${card.bgColor}`" style="height: 180px;">
        <div class="card-header d-flex justify-content-between align-items-center">
          <span class="card-title">{{ card.title }}</span>
           <i :class="[card.iconPrefix || 'fas', card.icon, 'fa-2x']"></i>
        </div>
        <div class="card-body d-flex flex-column justify-content-center">
          <p class="card-text">{{ card.description }}</p>
        </div>
      </div>
    </a>

    <!-- Internal route card -->
    <router-link
      v-else
      :to="{ name: card.route, params: { id: card.id } }"
      class="text-decoration-none"
    >
      <div class="card text-white" :class="`bg-${card.bgColor}`" style="height: 180px;">
        <div class="card-header d-flex justify-content-between align-items-center">
          <span class="card-title">{{ card.title }}</span>
           <i :class="[card.iconPrefix || 'fas', card.icon, 'fa-2x']"></i>
        </div>
        <div class="card-body d-flex flex-column justify-content-center">
          <p class="card-text">{{ card.description }}</p>
        </div>
      </div>
    </router-link>

  </div>
</div>

  </div>
</template>

<script>
import { getUserRole } from '@/components/values';

export default {
  data() {
    return {
      cards: [
        //{ id: '-res', title: 'Residents', description: "Residents' Information", bgColor: 'primary', icon: 'fa-user', route: 'residentslist' },        
        //{ id: '-chart', title: 'Charting Notes', description: "Residents' Charting Notes.", bgColor: 'info', icon: 'fa-file-alt', route: 'residentslist' },
        { id: '-offices', title: 'Office Locations', description: "Office Locations.", bgColor: 'info', icon: 'fa-home', route: 'offices' },
        { id: '-employeeslist', title: 'Employees', description: "Employees.", bgColor: 'success', icon: 'fa-user', route: 'employeeslist' },
        { id: '-time', title: 'Time Sheets', description: "Time Sheets.", bgColor: 'secondary', icon: 'fa-calendar', route: 'timesheets' },
        { id: '-payrollreports', title: 'Payroll Reports', description: "Payroll Reports.", bgColor: 'primary', icon: 'fa-file', route: 'payrollreports' }, 
        //{ id: '-vit', title: 'Vitals Information', description: "Residents' Vitals Information.", bgColor: 'danger', icon: 'fa-heartbeat', route: 'residentslist' },
        //{ id: '-adl', title: 'ADL', description: "Residents' ADL.", bgColor: 'dark', icon: 'fa-wheelchair', route: 'residentslist' }, 
        //{ id: '-ins', title: 'Insurances', description: "Residents' Insurance.", bgColor: 'success', icon: 'fa-microscope', route: 'residentslist' }, 
        //{ id: '-prov', title: 'Providers', description: "Residents' Providers.", bgColor: 'secondary', icon: 'fa-user-md', route: 'residentslist' }, 
        //{ id: '-doc', title: 'Documents', description: "Residents' Documents.", bgColor: 'warning', icon: 'fa-file', route: 'residentslist' }, 
        //{ id: '-cont', title: 'Contact', description: "Residents' Contacts.", bgColor: 'primary', icon: 'fa-phone', route: 'residentslist' }, 
        /**
        { id: 4, title: 'Task', description: "Manage residents' tasks.", bgColor: 'warning', icon: 'fa-tasks', route: 'task' },
        { id: 5, title: 'Orders', description: "Manage and schedule medications, vitals or treatments for residents.", bgColor: 'secondary', icon: 'fa-prescription', route: 'orders' },
        { id: 6, title: 'Cycle Refill', description: "Manage residents' orders refill cycle.", bgColor: 'success', icon: 'fa-sync', route: 'cycle-refill' },
        { id: 7, title: 'ADL', description: "Manage resident's ADL.", bgColor: 'dark', icon: 'fa-wheelchair', route: 'adl' },
        { id: 8, title: 'Medications', description: "Manage med passes, exceptions and request for change.", bgColor: 'success', icon: 'fa-pills', route: 'medications' },
        
  
  {
    id: '-playstore',
    title: 'Get Android App',
    description: 'Download from Google Play Store.',
    bgColor: 'warning',
    icon: 'fa-google-play',
    iconPrefix: 'fab',
    external: 'https://play.google.com/store/apps/details?id=com.melbournepersonalcare.melapp&pcampaignid=web_share'
  },

  
  {
    id: '-appstore',
    title: 'Get iOS App',
    description: 'Download from App Store.',
    bgColor: 'dark',
    icon: 'fa-apple',
    iconPrefix: 'fab',
    external: 'https://apps.apple.com/gb/app/melbourne-home-care-services/id6746638359'
  }
    */
      ],
      getUserRole,
    };
  },
  computed: {
  visibleCards() {
    return this.cards.filter((card) => {
      // Show all cards if user is an admin
      //console.log(this.getUserRole('admins'));
      if (this.getUserRole('admins')) return true;

      // For non-admins, hide the employees card
      //return card.id !== '-users';
      return !['-users', '-chart'].includes(card.id);
    });
  },
},


  methods: {
  navigateTo(card) {
    if (card.external) {
      window.open(card.external, '_blank');
    } else if (card.route) {
      this.$router.push({ name: card.route });
    }
  }
}


};
</script>

<style scoped>
.card {
  position: relative;
  height: 180px; /* Fixed height for all cards */
}
.card-body {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center; /* Center content vertically */
  text-align: center; /* Center content horizontally */
}
.card-title {
  font-weight: bold; /* Make the title bold */
}
.bg-purple {
    background-color: #6f42c1 !important; /* Bootstrap purple */
}
</style>
